import React from 'react';
import {useTranslate} from "./useTranslate";

function PageDisabled(props) {
    const translate = useTranslate();
    return (
        <div className="w-full h-full flex flex-column gap-2 align-items-center justify-content-center">
            <h1 className="english-font text-8xl m-0">{translate("disabled")}</h1>
            <span className="text-4xl">{translate("page-disabled")}</span>
        </div>
    );
}

export default PageDisabled;
